import React, { useState, useEffect } from "react";
import { Grid, Box } from "@mui/material";
import SideBar from "../../components/Sidebar/index";
import { Card, Space, Button, Tag } from "antd";
import Table from "../../components/Table/Index";
import { queenApiCalling } from "../../constant/API";
import { ToastContainer, toast } from "react-toastify";
import moment from "moment";
import "../../css/main.css";

export default function WalletHistory() {
  const [uid, setUid] = useState(window.location.pathname.split("/")[2]);
  const [name, setName] = useState(window.location.pathname.split("/")[3]);
  const [data, setData] = useState([]);
  const [col, setCol] = useState([
    {
      title: "Transaction Date/ Time",
      key: "id",
      render: (_, record) => (
        <p>
          {moment(_.time).format("M-d-yyyy")} / {moment(_.time).format("HH:ss")}
        </p>
      ),
    },

    {
      title: "Transaction Details",
      dataIndex: "comments",
      key: "comments",
    },
    {
      title: "Transaction ID",
      key: "code",
      dataIndex: "transaction_id",
    },
    {
      title: "Amount",
      key: "phone",
      render: (_, record) => <Tag color={"purple"}>{_.amount}</Tag>,
    },
  ]);

  const getUserListing = () => {
    queenApiCalling({ action: "GET_USERS_WALLET_TRANSACTION", uid: uid }).then(
      (res) => {
        if (Array.isArray(res)) {
          setData(res);
        }
      }
    );
  };

  useEffect(() => {
    getUserListing();
  }, [uid]);

  return (
    <Box>
      <Grid>
        <></>
      </Grid>
      <Box md={{ width: "100%" }} style={{ marginTop: "0px" }}>
        <Grid
          container
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 1, md: 1 }}
          sx={{ flexDirection: { xs: "column", md: "row" } }}
        >
          <Grid item md={2}>
            <SideBar type={localStorage.getItem("adminSession").role} />
          </Grid>
          <Grid
            md={10}
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 1, md: 1 }}
            sx={{ flexDirection: { xs: "column", md: "row" } }}
            style={{ marginTop: "0px" }}
          >
            <Card
              title={name.replace("%20", " ") + " - Wallet History"}
              style={{
                width: "98%",
                marginLeft: "1%",
                marginTop: "30px",
              }}
            >
              <Table data={data} col={col} />
            </Card>
          </Grid>
        </Grid>
      </Box>
      <ToastContainer />
    </Box>
  );
}
